import React, { Fragment } from 'react';

import cn from 'classnames';

import { Flex } from '@shared/ui';

import cls from './Banner.module.css';

interface IBannerProps {
    children: React.ReactNode;
    className?: string;
    as?: keyof React.JSX.IntrinsicElements;
    contentWrapperClassName?: string;
}

const BannerRoot = ({
    className,
    as: Tag = 'div',
    children,
    contentWrapperClassName,
}: IBannerProps) => (
    <Tag className={cn(cls.container, className)}>
        <Flex
            justify="between"
            align="center"
            wrap="wrap"
            className={cn(cls.content, contentWrapperClassName)}
        >
            {children}
        </Flex>
    </Tag>
);

const BannerTitle = ({ children }: { children: React.ReactNode }) => <>{children}</>;

const BannerDescription = ({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) => <div className={cn(cls.description, className)}>{children}</div>;

const BannerActions = ({
    children,
    className,
    dismissible = true,
    onDismiss,
    closeBtn,
}: {
    children: React.ReactNode;
    className?: string;
    dismissible?: boolean;
    onDismiss?: () => void;
    closeBtn?: React.ReactNode;
}) => (
    <div className={cn(cls.actions, className)}>
        {children}{' '}
        {dismissible
            ? closeBtn || (
                  <button
                      type="button"
                      onClick={onDismiss}
                      className={cls.closeBtn}
                      aria-label="Close banner"
                  />
              )
            : null}
    </div>
);

export const Banner = Object.assign(BannerRoot, {
    Title: BannerTitle,
    Description: BannerDescription,
    Actions: BannerActions,
});
